export default {
  "dashboard.title": "Dashboard",
  "auth.signIn.form.title": "SignIn",
  "auth.signIn.panel.title": "New Here?",
  "auth.signUp.form.title": "Sign Up",
  "auth.signUp.panel.title": "One of us?",
  "splashScreen.title": "LOADING",
  "dashboard.header.btn.submitGame": "Submit Game",
  "dashboard.submitGameDialog.gameStep.title": "Add your game session",
  "dashboard.submitGameDialog.gameStep.cta.button": "Submit Game!"
}